import { render, staticRenderFns } from "./AiAppSettingDefinitionEditForm.vue?vue&type=template&id=4b747c82&scoped=true"
import script from "./AiAppSettingDefinitionEditForm.vue?vue&type=script&lang=js"
export * from "./AiAppSettingDefinitionEditForm.vue?vue&type=script&lang=js"
import style0 from "./AiAppSettingDefinitionEditForm.vue?vue&type=style&index=0&id=4b747c82&prod&lang=css"
import style1 from "./AiAppSettingDefinitionEditForm.vue?vue&type=style&index=1&id=4b747c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b747c82",
  null
  
)

export default component.exports